import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b9566a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "c4e" }, "c4e", -1 /* HOISTED */))
const _hoisted_2 = {
  key: 0,
  class: "options-container"
}
const _hoisted_3 = { style: {"display":"grid","grid-template-columns":"repeat(1, 1fr)"} }
const _hoisted_4 = { style: {"display":"grid","grid-template-columns":"repeat(2, 1fr)"} }
const _hoisted_5 = { class: "text" }
const _hoisted_6 = { class: "center" }
const _hoisted_7 = { class: "text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "topMenu",
    onFocusout: $setup.closeDropdown,
    tabindex: "0",
    onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.toggleDropdown()))
  }, [
    _hoisted_1,
    ($setup.dropdown)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", null, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('HEADER.VERSION')), 1 /* TEXT */)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, _toDisplayString($setup.app_version + "/" + $setup.compilation_timestamp), 1 /* TEXT */)
              ])
            ]),
            _createCommentVNode("        <div style=\"display: grid; grid-template-columns: repeat(2, 1fr)\"  @click=\"topup\" v-if=\"isFaucetAvailable\">"),
            _createCommentVNode("          <div>"),
            _createCommentVNode("            <span class=\"text\">{{ $t('HEADER.TOP_UP_ACCOUNT') }}</span>"),
            _createCommentVNode("          </div>"),
            _createCommentVNode("          <div class=\"center\"><img class=\"\" src=\"@/assets/faucet.svg\" alt=\"Image\" style=\"width: 40px\"></div>"),
            _createCommentVNode("        </div>")
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ], 32 /* NEED_HYDRATION */))
}